import { chatSideBarAction, chatSideBarState } from '@/store'
import { Spin } from 'antd'
import { useMemo, useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'

export const Content = () => {
  const { sessionId, assistantSessions, historySessions } =
    useSnapshot(chatSideBarState)
  const [isLoading, setIsLoading] = useState(true)
  // eslint-disable-next-line valtio/state-snapshot-rule
  const historyItem = historySessions.find(item => item.sessionId === sessionId)
  let agentUrl = null
  if (historyItem) {
    agentUrl = historyItem.agent_url
  }
  if (
    sessionId === assistantSessions?.sessionId &&
    assistantSessions?.agent_url
  ) {
    agentUrl = assistantSessions?.agent_url
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { type, data } = event.data
      if (type === 'conversationComplete') {
        console.log('对话完成:', data)
        chatSideBarAction.getHistoryRecord()
      }
    }

    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  const handleIframeLoad = () => {
    console.log('iframe load')
    setIsLoading(false)
  }

  // eslint-disable-next-line valtio/state-snapshot-rule
  // agentUrl = 'http://localhost:3000/chatbot/H1LvRR20CGQVfveX?user_id=emR0Yy50ZXN0LjU1MDM'
  if (agentUrl) {
    return (
      <div className="relative h-full w-full">
        {isLoading && (
          <div className="h-full flex justify-center items-center">
            <Spin />
          </div>
        )}
        <iframe
          src={agentUrl}
          allow="microphone;camera;midi;encrypted-media;"
          className="fade-in h-full w-full border-none bg-white"
          title={'chatbox'}
          onLoad={handleIframeLoad}
        ></iframe>
      </div>
    )
  }
  return null
}

export default Content
